export const supportUrls = Object.freeze({
  intercomBaseUrl: "https://api-iam.intercom.io",
  faqUrl:
    "https://docs.saleshandy.com/en/articles/6969589-why-should-i-verify-my-email-list-before-sending-an-email-campaign",
});
